import React from 'react'
import ReactDOM from 'react-dom'
import 'index.css'
import {Toaster} from 'react-hot-toast'
import {registerLocale, setDefaultLocale} from 'react-datepicker'
import {ko} from 'date-fns/locale'
import {BrowserRouter} from "react-router-dom";
import {MainRouter} from 'pages/main/MainRouter'
import reportWebVitals from 'reportWebVitals'
import {RecoilRoot} from "recoil"
import {QueryClient, QueryClientProvider} from "react-query"

registerLocale("ko", ko)
setDefaultLocale("ko")

export const queryClient = new QueryClient()

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <RecoilRoot>
                    <Toaster position="top-right"/>
                    <MainRouter/>
                </RecoilRoot>
            </QueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
